import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";

export default function Market() {
  const { data: products = [] } = useQuery({ queryKey: ["products", "resale"], queryFn: async () => (await api.get("/products?origin=resale")).data });

  return (
    <div className="mx-auto max-w-[1600px] px-5 py-12 md:px-8" data-testid="market-page">
      <Seo title="Resale Market — The Hoodie Project®" description="One-of-one customized hoodies from our community of sellers and partners." />
      <div className="mb-10 border-b border-border pb-6">
        <p className="text-xs tracking-[0.3em] text-muted-foreground">COMMUNITY MARKETPLACE</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tighter md:text-7xl">RESALE MARKET</h1>
        <p className="mt-4 max-w-lg text-sm text-muted-foreground">One-of-one hoodies painted, dyed and reimagined by our community. Every purchase pays a real person — and often, a real cause.</p>
      </div>

      {products.length === 0 ? (
        <div className="border border-border p-12 text-center" data-testid="market-empty">
          <p className="text-muted-foreground">No resale drops live right now.</p>
          <p className="mt-2 text-sm text-muted-foreground">Want to sell your custom hoodies here?</p>
          <Link to="/register" className="mt-6 inline-block bg-white px-8 py-4 text-xs font-bold tracking-[0.2em] text-black hover:bg-neutral-300">BECOME A SELLER</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
